import React, { useCallback, Fragment, ReactElement } from 'react';
import Link from '@mui/material/Link';
import TextBlock from '../text-block/text-block.component';
import FormatService from '../../services/format-service';

const LinkText: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement | null => {
  const TARGET_BLANK: string = '_blank';

  const {
    isActive,
    text,
    links,
    extractLink,
    onClick,
  } = props;

  if (!text) {
    return null;
  }

  const renderLinkCallback: Function = useCallback((
    link: LinkItem,
    linkText: string,
    isActiveInternal: boolean,
  ): ReactElement => (
    isActiveInternal ? (
      <Link
        key={link.id}
        href={link.link}
        target={TARGET_BLANK}
        onClick={onClick}
      >
        {linkText}
      </Link>
    ) : (
      <TextBlock>
        {linkText}
      </TextBlock>
    )
  ), []);

  return (
    <Fragment>
      {FormatService.formatLinkedText(text, links, isActive, extractLink, false, renderLinkCallback)}
    </Fragment>
  );
});

export default LinkText;
